import React, { useRef } from 'react'
import { IBookData } from '../../App'
import './index.scss'
import ToClipBoard from '@/components/ToClipBoard'
import twitterLogo from '@kiss/assets/icons/icon_twitter.png'
import facebookLogo from '@kiss/assets/icons/icon_facebook.png'
import copyIcon from '@kiss/assets/icons/icon_copy.png'
import { clickGet } from '@/projects/kiss/utils/reportInfo/reportedMethods'
import { IClickGet } from '@/projects/kiss/utils/reportInfo/types'
import { isArray } from 'lodash'

const getShareText = (title: string) =>
  `I thought you'd be interested in reading "${title}" on Kiss. Read it here: `
interface IProps {
  bookData: IBookData | undefined
}

const BookInfo: React.FC<IProps> = (props) => {
  const { bookData } = props
  const bookUpdateStatus = bookData
    ? bookData?.update_status === 1
      ? 'Complete'
      : 'Ongoing'
    : undefined
  const getReadCountText = (): string => {
    if (!bookData) return ''
    const count = bookData.read_count
    if (count > 1000) {
      if (count < 1000000) {
        if (count % 1000 === 0) {
          return `${Math.floor(count / 1000)}k`
        } else {
          return `${Math.floor(count / 1000)}k+`
        }
      }
      if (count < 1000000000) {
        if (count % 1000000 === 0) {
          return `${Math.floor(count / 1000000)}m`
        } else {
          return `${Math.floor(count / 1000000)}m+`
        }
      }
      return `999m+`
    }
    return `${count}`
  }
  /** 上报参数的公共参数 */
  const clickParam = useRef<IClickGet>({
    eid: 12,
    parm5: 'h5_comic_share_click',
    parm9: location.href
  })

  const handlePushToTwitter = () => {
    // 上报点击Twitter
    clickGet({
      ...clickParam.current,
      parm1: 6
    })
    const url = `https://twitter.com/share?text=${getShareText(
      bookData?.book_title || ''
    )}&url=${encodeURIComponent(window.location.href)}`
    window.open(url, '_blank')
  }

  const handlePushToFacebook = () => {
    // 上报点击Facebook
    clickGet({
      ...clickParam.current,
      parm1: 7
    })

    const url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
      window.location.href
    )}&kid_directed_site=0&title=${getShareText(bookData?.book_title || '')}`
    window.open(url, '_blank')
  }

  // 取第一个作者名，作者名自动是数组，非数组就直接展示
  const getAuthor = (authorName: Array<string>) => {
    return Array.isArray(authorName) && authorName?.length > 0
      ? authorName[0]
      : authorName
  }

  const iconsData = [
    {
      key: 'twitter',
      render: (
        <img src={twitterLogo} key='twitter' onClick={handlePushToTwitter} />
      )
    },
    {
      key: 'facebook',
      render: (
        <img src={facebookLogo} key='facebook' onClick={handlePushToFacebook} />
      )
    },
    {
      key: 'copy',
      render: (
        <ToClipBoard key='copy'>
          <img
            id='copy-icon'
            src={copyIcon}
            key='copy'
            style={{ display: 'block' }}
            onClick={() => {
              // 上报点击Copy
              clickGet({
                ...clickParam.current,
                parm1: 8
              })
            }}
          />
          <></>
        </ToClipBoard>
      )
    }
  ]
  return (
    <>
      <div className='book-data-ctr'>
        <div className='bg-shadow'></div>
        <div
          className='blur-bg'
          style={{
            backgroundImage: bookData?.book_pic
              ? `url(${bookData?.book_pic})`
              : 'none'
          }}
        ></div>
        <div className='content-box'>
          <div className='cover-box'>
            <img src={bookData?.book_pic} alt='' />
          </div>
          <div className='book-data-box'>
            <div className='book-title'>{bookData?.book_title}</div>
            <div className='book-author'>
              Author：{getAuthor(bookData?.author_name || [])}
            </div>
            {/* <div className='book-info-box'>
                        <div className={`book-status ${bookData?.update_status === 1 ? 'book-status-completed' : 'book-status-ongoing'}`}>{bookUpdateStatus}</div>
                        <div className='book-reading'>{getReadCountText()}</div>
                        <div className='book-tag'>
                            <div>{bookData?.tag?.[0]}</div>
                        </div>
                    </div> */}

            <div className='book-from'>—— Comic from KISS</div>
          </div>
        </div>
      </div>
      <div className='icons-ctr'>{iconsData.map((item) => item.render)}</div>
    </>
  )
}

export default BookInfo
